
<b-container>
  <b-row>
    <b-col sm="12" md="12" lg="8" xl="8">
      <product-category-product-list :template-version="template_version"
                                     :quote-product="quote_product"
                                     :attributes-list="generatedDialogAttributesList"
                                     :prices-list="dialogPricesList">
      </product-category-product-list>
    </b-col>
    <b-col sm="12" md="12" lg="4" xl="4">
      <div class="position-sticky" style="top:70px">
        <product-category-product-summary :template-version="template_version"
                                     :quote-product="quote_product"
                                     :price-name="summaryPriceName">
        </product-category-product-summary>
        <configuration-dialog-buttons :quote-product="quote_product" :is-public="isPublic"></configuration-dialog-buttons>
      </div>
    </b-col>
  </b-row>
</b-container>
